import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';
import * as Types from '../types';

interface IProps {
  limit?: number;
  enabled?: boolean;
}

const useList = ({ limit = 20, enabled = true }: IProps = {}) => {
  const empty: Types.IApi.List.Response = { items: [], nextCursor: null, unreadCount: 0 };

  const { data, ...args } = useQuery({
    queryKey: ['notifications', 'list', limit],
    queryFn: async () => {
      const res = await Api.List({ limit });
      return res.data;
    },
    enabled,
  });

  return { ...args, ...(data ?? empty) };
};

export default useList;
